import { useEffect, useRef, useState } from 'react';

function useArcossPageChoose<T>(list: T[] = [], key: string, checkeds: number[] = []) {
  const [filters, setFilters] = useState<(typeof key)[]>([]);
  const currentCheckedMap = useRef<Map<typeof key, boolean>>(new Map());
  const [allCheckes, setAllCheckes] = useState<(typeof key)[]>([]);

  useEffect(() => {
    const filters = list.map(item => item[key]);
    setFilters(filters);
  }, [list]);

  useEffect(() => {
    const map = new Map();
    checkeds.forEach(checked => {
      map.set(checked, true);
    });
    currentCheckedMap.current = map;
  }, [checkeds]);

  useEffect(() => {
    // 暂时先不考虑数据需要保持一致性
    filters.forEach(filter => {
      const index = allCheckes.indexOf(filter);
      if (index < -1) {
        if (currentCheckedMap.current.has(filter)) {
          allCheckes.push(filter);
        } else {
          if (!currentCheckedMap.current.has(filter)) {
            allCheckes.splice(index, 1);
          }
        }
      }
      setAllCheckes([...allCheckes]);
    });
  }, [filters]);

  return allCheckes;
}

export default useArcossPageChoose;
